import { Component, OnInit } from '@angular/core';
import { SharedFunctions } from '@/core/utils/shared-functions';

@Component({
    selector: 'app-settings-apps',
    templateUrl: './settings-apps.component.html',
    // styleUrls: ['./settings-apps.component.scss'],
    standalone: false,
})
export class SettingsAppsComponent implements OnInit {
    displayDialogAndroid: boolean = false;
    displayDialogApple: boolean = false;

    ngOnInit(): void {
        // Empty
    }

    downloadAppWin(): void {
        SharedFunctions.downloadAppWin();
    }

    downloadAppMac(): void {
        SharedFunctions.downloadAppMac();
    }

    downloadAppLinux(): void {
        SharedFunctions.downloadAppLinux();
    }

    showDialogAndroid(): void {
        this.displayDialogAndroid = true;
    }

    showDialogApple(): void {
        this.displayDialogApple = true;
    }
}
